import { memo, Fragment, useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";

import {
  XMarkIcon,
  CheckIcon,
  ExclamationTriangleIcon,
  EyeIcon,
  AcademicCapIcon,
  UsersIcon,
  UserPlusIcon,
  UserMinusIcon,
  CheckCircleIcon,
  ExclamationCircleIcon,
} from "@heroicons/react/24/outline";

import Chart from "react-apexcharts";

import Container from "../components-layout/Container"; // Container toda app
import Layout from "../Layout"; // Layout toda app
import Header from "../components-layout/Header";

import Example from "./components/prueba";

import { fetchApi } from "../tools/apiCalls";
import WarningModal from "../components-modals/WarningModal";
import SearchForm from "../components-contabilidad-analisis/SearchForm";

const chartOptions = {
  chart: {
    type: "bar",
    height: 400,
    animations: {
      enabled: true,
      easing: "easeinout",
      speed: 800,
      animateGradually: {
        enabled: true,
        delay: 150,
      },
      dynamicAnimation: {
        enabled: true,
        speed: 350,
      },
    },
  },
  responsive: [
    {
      breakpoint: 480,
      options: {
        legend: {
          position: "bottom",
          offsetX: -10,
          offsetY: 0,
        },
      },
    },
  ],
  plotOptions: {
    bar: {
      borderRadius: 10,
      horizontal: false,
      columnWidth: "70%",
      endingShape: "rounded",
    },
  },
  stroke: {
    show: true,
    width: 2,
    colors: ["transparent"],
  },
  xaxis: {
    type: "category",
    position: "bottom",
    labels: {
      rotate: -45,
      style: {
        colors: Array(50).fill("#9197a1"),
        fontSize: "10px",
      },
    },
  },
  yaxis: {
    labels: {
      style: {
        colors: ["#9197a1"],
      },
    },
  },
  fill: {
    opacity: 1,
  },
  theme: {
    mode: "light",
    palette: "palette6",
  },
  dataLabels: {
    enabled: false,
    style: {
      colors: ["#fff"],
    },
  },
  legend: {
    position: "right",
    offsetX: 0,
    offsetY: 50,
    show: true,
    labels: {
      colors: ["#fff"],
    },
  },
  grid: {
    show: false,
  },
};

const dataFormatter = (objArray = []) => {
  const result = [];

  objArray.forEach(({ Sede, Porcentaje }) => {
    let sedeObj = result.find((item) => item.name === Sede);

    if (!sedeObj) {
      sedeObj = { name: Sede, data: [] };
      result.push(sedeObj);
    }

    sedeObj.data.push(Porcentaje);
  });

  return result;
};

const statuses = {
  Disponible: {
    Color: "text-green-600 bg-green-100 ring-green-400/10",
    Texto: "text-green-400",
    IconoS: CheckIcon,
    Descrip: "Disponible",
  },
  EnCierre: {
    Color: "text-yellow-700 bg-yellow-100 ring-yellow-400/10",
    Texto: "text-yellow-400",
    IconoS: ExclamationTriangleIcon,
    Descrip: "Por cerrar",
  },
  NoDisponible: {
    Color: "text-red-700 bg-red-100 ring-red-400/10",
    Texto: "text-red-400",
    IconoS: XMarkIcon,
    Descrip: "No Disponible",
  },
  Default: {
    Color: "text-green-600 bg-green-100 ring-green-400/10",
    Texto: "text-green-400",
    IconoS: CheckIcon,
    Descrip: "Historial",
  },
};

const classNames = (...classes) => {
  return classes.filter(Boolean).join(" ");
};

const Visita = () => {
  return (
    <div className="flex flex-col bg-secundarioMira">
      <ul className="bg-secundarioMira rounded-xl border border-secundarioMira shadow-md shadow-secundarioMiral">
        <dl className="text-base leading-6 mt-1">
          <div className="flex justify-center text-center gap-4">
            <EyeIcon className="h-6 w-6 text-secundario" aria-hidden="true" />
            <dt className="text-white">Última visita</dt>
            <dd className="text-grisMira font-semibold">03/02/2025</dd>
          </div>
          <div className="flex justify-center text-center gap-4">
            <dt className="text-white">Hora:</dt>
            <div className="text-grisMira font-semibold">10:00:00</div>
          </div>
        </dl>
        <div className="py-2 flex justify-center items-center">
          <button
            type="button"
            className="flex-initial w-[65%]  rounded-md border border-transparent bg-azulBrillanteMira py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-secundarioMira hover:border-azulLogos hover:border-2 focus:outline-none focus:ring-1 focus:ring-white focus:ring-offset-2"
          >
            <div className="flex justify-center">
              <AcademicCapIcon
                className="h-5 w-5 text-white"
                aria-hidden="true"
              />
              <p className="ml-1 px-2">Accede a tus cursos</p>
            </div>
          </button>
        </div>
      </ul>
    </div>
  );
};

const DashboardProfesores = () => {
  const user = useSelector((state) => state.auth.user);
  const userObj = JSON.parse(user);
  const [loading, setLoading] = useState(false);
  const cookies = new Cookies();
  const urlState2 = useSelector((state) => state.url.urlSchoolApi);
  const url =
    urlState2 === "" || urlState2 === undefined || urlState2 === null
      ? cookies.get("__urlSchoolApi")
      : urlState2;
  const { headersAPI: headers } = useSelector((state) => state.url);
  const [modal, setModal] = useState({ show: false, msg: "", ok: false });
  const [packs, setPacks] = useState([]);
  const [matxpacks, setMatxPacks] = useState([]);
  const [notasxpacks, setNotasxPacks] = useState([]);
  const [notasPorcentaje, setNotasPorcentaje] = useState([]);
  const [filteredPacks, setFilteredPacks] = useState([]);
  const [filteredNotas, setFilteredNotas] = useState([]);
  const [filteredPorcentaje, setFilteredPorcentaje] = useState([]);
  const [contador, setContador] = useState(3);
  const [unidad, setUnidad] = useState(0);
  const [fillPacks, setFillPacks] = useState(false);
  const [fillMatxPacks, setFillMatxPacks] = useState(false);
  const [fillNotasxPacks, setFillNotasxPacks] = useState(false);
  const [fillNotasPorcentaje, setFillNotasPorcentaje] = useState(false);
  const [infoPacks, setInfoPacks] = useState("");
  const [infoTitle, setInfoTitle] = useState("");
  const IdEmp = useSelector((state) => state.auth.IdEmp);

  const [showGrid, setShowGrid] = useState(false);
  const elementRef = useRef(null);

  const [filterData, setFilter] = useState([]);

  const [isLoaded, setIsLoaded] = useState(false);

  const searchParams = [
    "Sede",
    "Grado",
    "Materia",
    "IdPack",
    "Unidad",
    "Actividad",
  ];

  userObj.LoginId = userObj.LoginId.split(" ")
    .map((x) => {
      return x.charAt(0).toUpperCase() + x.slice(1).toLowerCase();
    })
    .join(" ");

  chartOptions.xaxis.categories =
    notasPorcentaje?.length > 0
      ? [...new Set(notasPorcentaje?.map((item) => item.Grado))]
      : [];

  useEffect(() => {
    const fetchPacks = async () => {
      setLoading(true);
      try {
        const res = await fetchApi({
          url: `${url}/utils/busquedas`,
          headers: headers,
          content: {
            opcion: "PACK_DASHBOARD",
            IdEmp,
          },
        });
        if (Array.isArray(res) && res.length > 0) {
          setPacks(res);
          setFilter(res);
          setFillPacks(true);
          if (elementRef.current) {
            elementRef.current.scrollIntoView({ behavior: "smooth" });
          }
        } else {
          setLoading(false);
          setPacks([]);
          setModal({
            show: true,
            msg: "Materias no asignadas, comuníquese con dirección académica",
            ok: false,
          });
        }
      } catch (error) {
        setLoading(false);
        setPacks([]);
        setModal({
          show: true,
          msg: "Error al hacer la solicitud de packs. Intente de nuevo.",
          ok: false,
        });
      } finally {
      }
    };

    fetchPacks();
  }, [headers, url]);

  useEffect(() => {
    const fetchMatxPacks = async () => {
      setLoading(true);
      try {
        const res = await fetchApi({
          url: `${url}/utils/busquedas`,
          headers: headers,
          content: {
            opcion: "MAT_PACK",
            IdEmp,
          },
        });
        if (Array.isArray(res) && res.length > 0) {
          setMatxPacks(res);
          const filtered = res.filter(
            (r) =>
              r.IdSede === packs[0].IdSede &&
              r.IdGrado === packs[0].IdGrado &&
              r.IdUnidad === packs[0].IdUnidad &&
              r.IdMateria === packs[0].IdMateria &&
              r.IdPack === packs[0].IdPack,
          );
          setFilteredPacks(filtered);
          setInfoPacks(
            `${packs[0].Sede} - ${packs[0].Grado} - ${packs[0].Unidad}`,
          );
          setInfoTitle(packs[0].Paquete);
          setFillMatxPacks(true);
          if (elementRef.current) {
            elementRef.current.scrollIntoView({ behavior: "smooth" });
          }
        } else {
          setLoading(false);
          setMatxPacks([]);
          setModal({
            show: true,
            msg: "Materias no asignadas, comuníquese con dirección académica",
            ok: false,
          });
        }
      } catch (error) {
        setLoading(false);
        setMatxPacks([]);
        setModal({
          show: true,
          msg: "Error al hacer la solicitud de packs. Intente de nuevo.",
          ok: false,
        });
      } finally {
        // setLoading(false);
      }
    };
    if (fillPacks) {
      fetchMatxPacks();
    }
  }, [headers, url, fillPacks, packs]);

  useEffect(() => {
    const fetchNotasxPacks = async () => {
      setLoading(true);
      try {
        const res = await fetchApi({
          url: `${url}/utils/busquedas`,
          headers: headers,
          content: {
            opcion: "NOT_PACK",
            IdEmp,
          },
        });
        if (Array.isArray(res) && res.length > 0) {
          setNotasxPacks(res);
          const filtered = res.filter(
            (r) =>
              r.IdSede === packs[0].IdSede &&
              r.IdGrado === packs[0].IdGrado &&
              r.IdUnidad === packs[0].IdUnidad &&
              r.IdMateria === packs[0].IdMateria &&
              r.IdPack === packs[0].IdPack &&
              r.IdSeccion === packs[0].IdSeccion,
          );
          setFilteredNotas(filtered);
          setInfoPacks(
            `${packs[0].Sede} - ${packs[0].Grado} - ${packs[0].Unidad}`,
          );
          setInfoTitle(packs[0].Paquete);
          setFillNotasxPacks(true);
          if (elementRef.current) {
            elementRef.current.scrollIntoView({ behavior: "smooth" });
          }
        } else {
          setLoading(false);
          setMatxPacks([]);
          setModal({
            show: true,
            msg: "Materias no asignadas, comuníquese con dirección académica",
            ok: false,
          });
        }
      } catch (error) {
        setLoading(false);
        setMatxPacks([]);
        setModal({
          show: true,
          msg: "Error al hacer la solicitud de packs. Intente de nuevo.",
          ok: false,
        });
      } finally {
        // setLoading(false);
      }
    };
    if (fillMatxPacks) {
      fetchNotasxPacks();
    }
  }, [headers, url, fillMatxPacks, packs]);

  useEffect(() => {
    const fetchNotasPorcentaje = async () => {
      setLoading(true);
      try {
        const res = await fetchApi({
          url: `${url}/utils/busquedas`,
          headers: headers,
          content: {
            opcion: "POR_NOTAS",
            IdEmp,
          },
        });
        if (Array.isArray(res) && res.length > 0) {
          setNotasPorcentaje(res);
          // setLoading(false);
          const filtered = res.filter((r) => r.IdUnidad === packs[0].IdUnidad);
          setFilteredPorcentaje(filtered);
          setUnidad(packs[0].IdUnidad);
          setFillNotasPorcentaje(true);
          if (elementRef.current) {
            elementRef.current.scrollIntoView({ behavior: "smooth" });
          }
        } else {
          setLoading(false);
          setNotasPorcentaje([]);
          setModal({
            show: true,
            msg: "Materias no asignadas, comuníquese con dirección académica",
            ok: false,
          });
        }
      } catch (error) {
        setLoading(false);
        setNotasPorcentaje([]);
        setModal({
          show: true,
          msg: "Error al hacer la solicitud de packs. Intente de nuevo.",
          ok: false,
        });
      } finally {
        setLoading(false);
      }
    };
    if (fillNotasxPacks) {
      fetchNotasPorcentaje();
    }
  }, [headers, url, fillNotasxPacks, packs]);

  const filteredInfoPacks = (data) => {
    const filtered = matxpacks.filter(
      (r) =>
        r.IdSede === data.IdSede &&
        r.IdGrado === data.IdGrado &&
        r.IdUnidad === data.IdUnidad &&
        r.IdMateria === data.IdMateria &&
        r.IdPack === data.IdPack,
    );
    const filteredNotas = notasxpacks.filter(
      (r) =>
        r.IdSede === data.IdSede &&
        r.IdGrado === data.IdGrado &&
        r.IdUnidad === data.IdUnidad &&
        r.IdMateria === data.IdMateria &&
        r.IdPack === data.IdPack &&
        r.IdSeccion === data.IdSeccion,
    );
    if (unidad !== data.IdUnidad) {
      const filteredPor = notasPorcentaje.filter(
        (r) => r.IdUnidad === data.IdUnidad,
      );
      setUnidad(data.IdUnidad);
      setFilteredPorcentaje(filteredPor);
    }
    setInfoPacks(`${data.Sede} - ${data.Grado} - ${data.Unidad}`);
    setInfoTitle(data.Paquete);
    setFilteredPacks(filtered);
    setFilteredNotas(filteredNotas);
  };

  const handleCloseGrid = () => {
    setModal({
      show: false,
    });
    setShowGrid(false);
  };

  // Busqueda
  const handleQuery = (values) => {
    doSearch(values.query.trim());
  };

  const doSearch = (query) => {
    if (query === null) {
      setFilter(packs);
    } else {
      setFilter(
        packs.filter((x) => {
          return searchParams.some((y) => {
            return (
              x[y]?.toString().toLowerCase().indexOf(query.toLowerCase()) > -1
            );
          });
        }),
      );
    }
  };
  // Fin busqueda
  //
  useEffect(() => {
    // Simula una carga después de 1 segundo
    if (!loading && fillNotasPorcentaje) {
      const timer = setTimeout(() => {
        setIsLoaded(true);
      }, 700);

      return () => clearTimeout(timer);
    }
  }, [loading, fillNotasPorcentaje]);

  return (
    <div ref={elementRef}>
      <WarningModal
        open={loading}
        image={<img src="./img/loader.gif" alt="loading" />}
        opacity="bg-opacity-100"
      />
      <WarningModal
        open={modal.show ? true : false}
        width={showGrid ? "w-[40%]" : ""}
        image={
          showGrid ? null : modal.ok ? (
            <CheckCircleIcon className="h-20 w-20 text-green-500 mx-auto" />
          ) : (
            <ExclamationCircleIcon className="h-20 w-20 text-red-500 mx-auto" />
          )
        }
        title={showGrid ? "" : "Aviso"}
        subtitle={<span>{modal.msg}</span>}
        opacity="bg-opacity-50"
      >
        {showGrid ? (
          <div>
            <UltimaActividad
              title={"Información"}
              width={"w-[100%]"}
              visita={false}
              datos={filteredPacks}
              infoPacks={infoPacks}
              infoTitle={infoTitle}
              contador={filteredPacks.length}
              setShowGrid={setShowGrid}
              setModal={setModal}
              sizeFont={"text-base"}
            />
            <div className="mt-5 sm:mt-6">
              <button
                onClick={() => {
                  handleCloseGrid();
                  if (modal.reload) {
                    window.location.reload();
                  }
                  setModal((curr) => ({
                    ...curr,
                    show: false,
                    reload: true,
                  }));
                }}
                type="button"
                className="inline-flex w-full justify-center rounded-md border border-transparent bg-azulBrillanteMira px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-secundario transition duration-500 ease focus:outline-none sm:text-sm"
              >
                Entendido
              </button>
            </div>
          </div>
        ) : (
          <button
            onClick={() => {
              if (modal.reload) {
                window.location.reload();
              }
              handleCloseGrid();
            }}
            type="button"
            className="inline-flex w-full justify-center rounded-md border border-transparent bg-azulBrillanteMira px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-secundario transition duration-500 ease focus:outline-none sm:text-sm"
          >
            Entendido
          </button>
        )}
      </WarningModal>
      <Layout userObj={userObj} activeTab="Dashboard">
        <Container height="h-full">
          <Header title={`Dashboard ${userObj.LoginId}`} />
          {packs?.length === 0 && !loading && (
            <h2 className="mx-auto max-w-7xl text-3xl font-semibold leading-10 text-secundario lg:mx-0 lg:max-w-none text-center">
              Materias no asignadas, comuníquese con dirección académica
            </h2>
          )}
          {!loading && fillNotasPorcentaje && (
            <div
              className={`bg-blueGray-900 px-4 py-4 rounded-xl shadow-md shadow-grisMira ${
                isLoaded
                  ? "opacity-100 translate-y-0"
                  : "opacity-0 translate-y-10"
              }`}
            >
              {contador > 3 && packs?.length > 0 && (
                <SearchForm handleQuery={handleQuery} />
              )}

              {filterData?.length === 0 && contador > 3 ? (
                <>
                  <h2 className="mx-auto max-w-7xl text-3xl font-semibold leading-10 text-secundario lg:mx-0 lg:max-w-none text-center">
                    No se encontraron resultados para tu búsqueda.
                  </h2>
                  <div className="lg:flex lg:justify-end">
                    <button
                      onClick={() => {
                        setContador(packs?.length);
                        setFilter(packs);
                      }}
                      type="button"
                      className="w-1/5 justify-end rounded-md border border-transparent bg-azulBrillanteMira px-4 py-2 text-base font-semibold text-white shadow-sm hover:bg-secundario transition duration-500 ease focus:outline-none sm:text-base"
                    >
                      Regresar
                    </button>
                  </div>
                </>
              ) : (
                <div
                  className={`flex ${contador > 3 && packs?.length > 0 && "mt-4"} flex-row gap-4`}
                >
                  <div className="relative px-4 py-4 flex flex-col md:flex-row gap-4 justify-between bg-primarioMira rounded-md shadow-md shadow-primarioMira">
                    <p className="absolute top-2 left-4 text-white font-medium text-2xl cursor-pointer mb-4 hover:text-secundario transition duration-500 ease">
                      Mis cursos asignados
                    </p>
                    <p
                      onClick={() => {
                        contador > 3
                          ? setContador(3)
                          : setContador(packs?.length);
                        setFilter(packs);
                      }}
                      className="absolute top-2 right-4 text-azulBrillanteMira font-medium text-base cursor-pointer mb-4 hover:text-secundario transition duration-500 ease"
                    >
                      {contador > 3 ? "Ver menos" : "Ver todo"}
                    </p>
                    <div
                      className={classNames(
                        contador <= 3
                          ? "mt-8 flex flex-col md:flex-row gap-6"
                          : "mt-4 grid grid-cols-4 2xl:grid-cols-4 md:grid-cols-4 gap-6 overflow-x-auto flex-row gap-x-6 py-4 h-full px-4",
                      )}
                    >
                      {filterData?.length > 0 && (
                        <Cards
                          data={filterData}
                          contador={contador}
                          filtered={filteredInfoPacks}
                        />
                      )}
                    </div>
                  </div>

                  {contador <= 3 && (
                    <UltimaActividad
                      title={"Información"}
                      width={"w-[30%]"}
                      visita={true}
                      datos={filteredPacks}
                      infoPacks={infoPacks}
                      infoTitle={infoTitle}
                      contador={4}
                      setShowGrid={setShowGrid}
                      setModal={setModal}
                      sizeFont={"text-xs"}
                    />
                  )}
                </div>
              )}

              {contador <= 3 && (
                <div className="mt-6 flex flex-col md:flex-row gap-8 w-full">
                  <UltimaActividad2
                    title={"Últimas notas ingresadas"}
                    width={"w-[50%]"}
                    visita={false}
                    datos={filteredNotas}
                    infoPacks={infoPacks}
                    infoTitle={infoTitle}
                    contador={5}
                    sizeFont={"text-sm"}
                  />
                  <div className="flex-grow bg-primarioMira rounded-md shadow-md shadow-primarioMira w-[70%] text-center">
                    <p className="py-2 text-white text-lg font-semibold">
                      {`Porcentaje de notas ingresadas ${filteredPorcentaje[0].Unidad}`}
                    </p>
                    <Chart
                      options={chartOptions}
                      series={dataFormatter(filteredPorcentaje)}
                      height="430px"
                      type="bar"
                    />
                  </div>
                  <div className="bg-primarioMira flex-grow px-4 rounded-md shadow-md shadow-primarioMira w-[40%]">
                    <Example data={packs} contador={5} />
                  </div>
                </div>
              )}
            </div>
          )}
        </Container>
      </Layout>
      )
    </div>
  );
};

const UltimaActividad2 = ({
  title = "",
  width = "w-full",
  visita = false,
  datos = [],
  infoPacks,
  infoTitle,
  contador,
  sizeFont,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const itemsPerPage = 5;

  // Lógica de filtrado
  const filteredPacks = datos.filter((pack) =>
    pack.Materia.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  // Lógica de paginación
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentPacks = filteredPacks.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredPacks.length / itemsPerPage);

  return (
    <div
      className={`space-y-8 py-2 xl:space-y-12 bg-primarioMira rounded-md shadow-md shadow-primarioMira ${width}`}
    >
      <div>
        {visita && <Visita />}
        <div className="mt-1 mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <h2 className="mx-auto max-w-2xl text-xl font-semibold leading-6 text-white lg:mx-0 lg:max-w-none text-center">
            {`${title} ${infoTitle}`}
          </h2>
        </div>
        <div className="mt-2 overflow-scroll md:overflow-hidden border-t border-gray-100">
          <div className="mx-auto max-w-7xl">
            <div className="mx-auto max-w-7xl lg:mx-0 lg:max-w-none">
              <table className="w-full text-left">
                <tbody>
                  <Fragment key={"Paquetes"}>
                    <tr className="text-base leading-5 text-white text-center">
                      <th
                        scope="colgroup"
                        colSpan={3}
                        className="relative isolate py-2 font-semibold"
                      >
                        <div>{infoPacks}</div>
                        <div className="mt-1">{datos[0]?.Materia}</div>
                      </th>
                    </tr>
                    {currentPacks?.length === 0 ? (
                      <div className="mt-1 mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                        <h2 className="mx-auto max-w-7xl text-2xl font-semibold leading-10 text-secundario lg:mx-0 lg:max-w-none text-center">
                          No hay notas registradas hasta el momento.
                        </h2>
                      </div>
                    ) : (
                      currentPacks?.map((detail, idx) => {
                        if (idx < contador) {
                          return (
                            <tr
                              key={idx}
                              className={`${idx % 2 === 0 ? "bg-blueGray-700" : "bg-blueGray-800"} "w-full"`}
                            >
                              <td className="px-2 relative pr-6">
                                <div className="flex gap-x-4">
                                  <div className="flex-auto">
                                    <div className="flex items-start gap-x-2">
                                      <div
                                        className={`${sizeFont} font-medium leading-4 text-white`}
                                      >
                                        {detail?.Carnet}
                                      </div>
                                    </div>
                                    <div
                                      className={`mt-1 ${sizeFont} leading-4 text-grisMira`}
                                    >
                                      {detail?.Alumno}
                                    </div>
                                  </div>
                                </div>
                              </td>
                              <td className="hidden py-2 pr-2 sm:table-cell">
                                <div
                                  className={`${sizeFont} leading-4 text-white`}
                                >
                                  {detail?.Actividad}
                                </div>
                                <div
                                  className={`mt-0.5 ${sizeFont} leading-4 text-grisMira`}
                                >
                                  {detail?.Nota}
                                </div>
                              </td>
                            </tr>
                          );
                        } else {
                          return null;
                        }
                      })
                    )}
                  </Fragment>
                </tbody>
              </table>
            </div>
            {currentPacks?.length > 0 && (
              <div className="mt-4 flex justify-between items-center text-gray-300">
                <span className="text-gray-400">
                  Página {currentPage} de {totalPages}
                </span>
                <div className="flex space-x-2">
                  <button
                    onClick={() =>
                      setCurrentPage((prev) => Math.max(prev - 1, 1))
                    }
                    disabled={currentPage === 1}
                    className="px-3 py-1 bg-gray-700 rounded disabled:opacity-50 hover:bg-gray-900"
                  >
                    Anterior
                  </button>
                  <button
                    onClick={() =>
                      setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                    }
                    disabled={currentPage === totalPages}
                    className="px-3 py-1 bg-gray-700 rounded disabled:opacity-50 hover:bg-gray-900"
                  >
                    Siguiente
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const UltimaActividad = ({
  title = "",
  width = "w-full",
  visita = false,
  datos = [],
  infoPacks,
  infoTitle,
  contador,
  setShowGrid,
  setModal,
  sizeFont,
}) => {
  return (
    <div
      className={`space-y-8 py-2 xl:space-y-12 bg-primarioMira rounded-md shadow-md shadow-primarioMira ${width}`}
    >
      <div>
        {visita && <Visita />}
        <div className="mt-1 mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <h2 className="mx-auto max-w-2xl text-xl font-semibold leading-6 text-white lg:mx-0 lg:max-w-none text-center">
            {`${title} ${infoTitle}`}
          </h2>
        </div>
        <div className="mt-2 overflow-scroll md:overflow-hidden border-t border-gray-100">
          <div className="mx-auto max-w-7xl">
            <div className="mx-auto max-w-7xl lg:mx-0 lg:max-w-none">
              <table className="w-full text-left">
                <tbody>
                  <Fragment key={"Paquetes"}>
                    <tr className="text-base leading-5 text-white text-center">
                      <th
                        scope="colgroup"
                        colSpan={3}
                        className="relative isolate py-2 font-semibold"
                      >
                        <div>{infoPacks}</div>
                        <div className="mt-1">{datos[0]?.Materia}</div>
                      </th>
                    </tr>
                    {datos?.length === 0 ? (
                      <div className="mt-1 mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                        <h2 className="mx-auto max-w-7xl text-2xl font-semibold leading-10 text-secundario lg:mx-0 lg:max-w-none text-center">
                          No hay régimen activo por el momento.
                        </h2>
                      </div>
                    ) : (
                      datos?.map((detail, idx) => {
                        let IconoS = statuses[detail?.Estado]?.IconoS;
                        if (idx < contador) {
                          return (
                            <tr
                              key={idx}
                              className={`${idx % 2 === 0 ? "bg-blueGray-700" : "bg-blueGray-800"} "w-full"`}
                            >
                              <td className="relative pr-6">
                                <div className="px-1 flex gap-x-4">
                                  <IconoS
                                    className={classNames(
                                      statuses[detail?.Estado]?.Texto,
                                      "hidden h-7 w-6 flex-none sm:block",
                                    )}
                                    aria-hidden="true"
                                  />
                                  <div className="flex-auto">
                                    <div className="flex items-start gap-x-2">
                                      <div
                                        className={`${sizeFont} font-medium leading-4 text-white`}
                                      >
                                        {detail?.Actividad}
                                      </div>
                                      <div
                                        className={classNames(
                                          statuses[detail?.Estado]?.Color,
                                          `rounded-md py-1 px-1 text-xs font-medium ring-1 ring-inset`,
                                        )}
                                      >
                                        {statuses[detail?.Estado]?.Descrip}
                                      </div>
                                    </div>
                                    <div
                                      className={`mt-1 ${sizeFont} leading-4 text-grisMira`}
                                    >
                                      {detail?.VenceActividad}
                                    </div>
                                  </div>
                                </div>
                              </td>
                              <td className="hidden py-2 pr-2 sm:table-cell">
                                <div
                                  className={`${sizeFont} leading-4 text-white`}
                                >
                                  {detail?.Descripcion.substring(0, 23)}
                                </div>
                                <div
                                  className={`mt-0.5 ${sizeFont} leading-4 text-grisMira`}
                                >
                                  {detail?.FechaActividad}
                                </div>
                              </td>
                            </tr>
                          );
                        } else {
                          return null;
                        }
                      })
                    )}
                  </Fragment>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        {contador !== datos?.length && (
          <button
            className="w-full p-1 rounded-b-md px-auto py-auto text-center text-md text-gray-100 hover:bg-secundario bg-azulBrillanteMira flex flex-row justify-center transition duration-500 ease"
            onClick={() => {
              setShowGrid(true);
              setModal({
                show: true,
                msg: "",
                ok: false,
              });
            }}
          >
            Ver más
          </button>
        )}
      </div>
    </div>
  );
};

const Cards = ({ data, contador, filtered }) => {
  const dirWebApp = process.env.REACT_APP_DIR_PRO;
  const [active, setActive] = useState(0);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [confirmText, setConfirmText] = useState("");
  const [missingWord, setMissingWord] = useState({ word: "", index: -1 });
  const [selectedPack, setSelectedPack] = useState(null);

  // Función para obtener una palabra aleatoria de la materia
  const getRandomMissingWord = (materia) => {
    const words = materia.split(" ");
    // Solo consideramos palabras con 3 o más caracteres
    const validWords = words.filter((word) => word.length >= 3);
    const randomIndex = Math.floor(Math.random() * validWords.length);
    const selectedWord = validWords[randomIndex];

    // Encontramos el índice original de la palabra en el array completo
    const originalIndex = words.findIndex((word) => word === selectedWord);

    return {
      word: selectedWord,
      index: originalIndex,
    };
  };

  const handleSelect = (dat) => {
    if (dat) {
      setSelectedPack(dat);
      const newMissingWord = getRandomMissingWord(dat.Materia);
      setMissingWord(newMissingWord);
      setShowConfirmModal(true);
      setConfirmText("");
    }
  };

  const navigate = useNavigate();
  const handleConfirm = () => {
    if (confirmText.toLowerCase() === missingWord.word.toLowerCase()) {
      setShowConfirmModal(false);
      setConfirmText("");
      setMissingWord({ word: "", index: -1 });
      navigate(`${dirWebApp}ingresar-actividad`, {
        state: { Pack: selectedPack },
      });
    }
  };

  return (
    <>
      {data?.map((dat, idx) => {
        if (idx < contador) {
          return (
            <div
              key={idx}
              onMouseEnter={() => {
                setActive(idx);
                filtered(dat);
              }}
              className={classNames(
                idx === active
                  ? "transition duration-500 ease flex flex-col justify-between overflow-hidden rounded-2xl border-2 bg-primarioMira shadow-md shadow-white hover:bg-primarioMira hover:shadow-white hover:border-2"
                  : "transition duration-500 ease flex flex-col justify-between overflow-hidden rounded-2xl bg-secundarioMira shadow-lg shadow-blueGray-950 hover:bg-primarioMira hover:shadow-white hover:border-2",
              )}
            >
              <div className="p-4">
                <div className="flex justify-between">
                  <div className="flex-1 flex flex-row">
                    <div className="w-full">
                      <div className="text-lg text-gray-100 font-sm flex flex-row justify-between">
                        <div className="flex flex-row justify-between w-full mb-2">
                          <div className="flex flex-col 2xl:flex-row gap-2">
                            <p className="font-medium text-xl self-end">
                              Campus
                            </p>
                            <p className="text-azulBrillanteMira font-medium text-xl self-end">
                              {dat.Sede}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="flex flex-col 2xl:flex-row gap-2">
                        <p className="text-azulBrillanteMira font-medium text-xl w-full">
                          {dat.Paquete}
                        </p>
                      </div>
                      <p className="text-secundario font-medium text-lg">
                        {dat.Materia}
                      </p>
                      <div className="mt-2 text-md text-gray-400 flex flex-col lg:flex-row justify-between gap-2">
                        <div className="flex flex-col justify-end mb-2">
                          <span className="rounded-md truncate text-xl font-medium inline-flex text-gray-100">
                            <div className="flex flex-col">
                              <div className="flex flex-row gap-2 //justify-between">
                                <p className="self-end text-lg">Grado</p>
                                <p className="self-end text-secundario text-lg">
                                  {dat.Grado}
                                </p>
                              </div>
                              <div className="flex flex-row gap-2 //justify-between">
                                <p className="self-end text-lg">Sección</p>
                                <p className="self-end text-secundario text-lg">
                                  {dat.IdSeccion}
                                </p>
                              </div>
                            </div>
                          </span>
                          <div className="flex flex-col">
                            <p className="text-white text-base font-semibold">
                              {dat.Unidad}
                            </p>
                            <p className="text-white text-base font-semibold">
                              {dat.Actividad}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="my-4">
                  <Iconos
                    dat1={dat.AlumnosNotas}
                    dat2={dat.ConNotas}
                    dat3={dat.SinNotas}
                  />
                </div>
              </div>

              <div className="flex justify-between px-5">
                <div aria-hidden="true" className="w-[85%] py-1">
                  <div className="overflow-hidden rounded-full bg-gray-600">
                    <div
                      style={{ width: `${dat.Porcentaje}%` }}
                      className={classNames(
                        dat.Porcentaje === 100
                          ? "bg-green-500 text-green-900"
                          : dat.Porcentaje >= 75 && dat.Porcentaje < 100
                            ? "bg-yellow-500 text-yellow-900"
                            : dat.Porcentaje > 50 && dat.Porcentaje < 75
                              ? "bg-orange-200 text-orange-900"
                              : "bg-red-500 text-red-900",
                        "rounded-md p-1 font-medium",
                      )}
                    />
                  </div>
                </div>
                <div className="py-1">
                  <dd
                    className={classNames(
                      dat.Porcentaje === 100
                        ? "bg-green-200 text-green-900"
                        : dat.Porcentaje >= 75 && dat.Porcentaje < 100
                          ? "bg-yellow-200 text-yellow-900"
                          : dat.Porcentaje > 50 && dat.Porcentaje < 75
                            ? "bg-orange-200 text-orange-900"
                            : "bg-red-200 text-red-900",
                      "rounded-md p-1 font-medium",
                    )}
                  >{`${dat.Porcentaje}%`}</dd>
                </div>
              </div>
              <button
                className="w-full p-2 rounded-b-md px-auto py-auto text-center text-md text-gray-100 hover:bg-secundario bg-azulBrillanteMira flex flex-row justify-center transition duration-500 ease"
                onClick={() => handleSelect(dat)}
              >
                Detalle
              </button>
            </div>
          );
        } else {
          return null;
        }
      })}

      {showConfirmModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-[#1b2635] p-6 rounded-lg w-[600px] border border-gray-700">
            <h3 className="text-xl font-bold text-gray-200 mb-4">
              Confirmar selección
            </h3>

            <div className="mb-6">
              <div className="flex flex-row gap-4">
                <p className="text-gray-300 font-semibold mb-2 text-lg">
                  Materia seleccionada:
                </p>
                <p className="text-blue-400 text-lg font-medium mb-4">
                  {selectedPack.Materia}
                </p>
              </div>
              <p className="text-gray-300 mb-4">
                Escribe la palabra que hace falta sin ESPACIOS:
              </p>
              <div className="p-4 bg-gray-700 rounded">
                <div className="flex items-center flex-wrap gap-2 text-lg">
                  {selectedPack.Materia.split(" ").map((word, index) =>
                    index === missingWord.index ? (
                      <input
                        key={index}
                        type="text"
                        value={confirmText}
                        onChange={(e) => setConfirmText(e.target.value)}
                        className="w-32 px-2 py-1 bg-gray-600 border border-gray-500 rounded text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 text-center"
                        placeholder="________"
                        style={{
                          minWidth: `${missingWord.word.length * 12}px`,
                        }}
                      />
                    ) : (
                      <span key={index} className="text-white">
                        {word}
                      </span>
                    ),
                  )}
                </div>
              </div>
            </div>

            <div className="flex justify-end space-x-3">
              <button
                onClick={() => {
                  setShowConfirmModal(false);
                  setConfirmText("");
                  setMissingWord({ word: "", index: -1 });
                }}
                className="px-4 py-2 bg-gray-700 text-gray-200 rounded hover:bg-gray-600"
              >
                Cancelar
              </button>
              <button
                onClick={handleConfirm}
                disabled={
                  confirmText.toLowerCase() !== missingWord.word.toLowerCase()
                }
                className={`px-4 py-2 rounded transition-colors duration-200
            ${
              confirmText.toLowerCase() === missingWord.word.toLowerCase()
                ? "bg-blue-600 text-white hover:bg-blue-700"
                : "bg-gray-600 text-gray-400 cursor-not-allowed"
            }`}
              >
                Confirmar
              </button>
            </div>

            {/* Pista */}
            <div className="mt-4 text-sm text-gray-400">
              <p>Pista: La palabra tiene {missingWord.word.length} letras</p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const Iconos = ({ dat1, dat2, dat3 }) => {
  return (
    <div className="flex flex-row gap-2 /bg-red-200">
      <div className="flex flex-col w-1/3 bg-yellow-200 text-yellow-900 rounded-xl p-2 text-right font-medium">
        <UsersIcon className="w-5 h-5 text-yellow-900 mx-auto" />
        <div className="/truncate text-sm text-yellow-900 text-center">
          {dat1}
        </div>
      </div>

      <div className="flex flex-col w-1/3 bg-green-200 text-green-900 rounded-xl p-2 text-right font-medium">
        <UserPlusIcon className="w-5 h-5 text-green-900 mx-auto" />
        <div className=" /truncate text-sm text-green-900 text-center">
          <p>{dat2}</p>
        </div>
      </div>

      <div className="flex flex-col w-1/3 bg-red-200 text-red-900 rounded-xl p-2 text-right font-medium">
        <UserMinusIcon className={"w-5 h-5 text-red-900  mx-auto"} />
        <div className=" /truncate text-sm text-red-900 text-center">
          {dat3}
        </div>
      </div>
    </div>
  );
};

export default memo(DashboardProfesores);
